import React from 'react'
import { ProjectStackCard } from './ProjectStackCard'

export const Project = ({name, link, img, overview, stack}) => {
    const renderProjectStack = stack.map(stackItem => (
        <ProjectStackCard item={stackItem}/>
    ));

  return (
    <div class="project">
        <div class="project-preview">
            <a href={link}>
                <img src={img} alt={name} />
            </a>
        </div>
            <h2>{name}</h2>
            <p>{overview}</p>
        <div class="project-stack-container">
            {renderProjectStack}
        </div>
    </div>
  )
}
